import { useContext } from "react";
import { useMutation } from "@tanstack/react-query";
import { axiosPost } from "@/services/axiosService";
import processQuestions from "../utils/processQuestions";
import { BotContext } from "../store";
import { nanoid } from "nanoid";
import { State } from "@/redux/Types";
import { useSelector } from "react-redux";
import { sendEventToOutgrow } from "@/pages/cbb-builder/outgrow-event.service";

export default function useBotSave() {
  const [store, storeDispatch] = useContext(BotContext); //
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);

  return useMutation({
    mutationKey: ["bot", "saveBotInOne"],
    mutationFn: async (botData: Record<string, any>) => {
      const questionData = processQuestions(botData);

      const promptCacheKey =
        botData?.aiBotConfig?.promptCacheKey || nanoid(5) + "@pck";

      const botDataClone = structuredClone(botData);
      const isTrained = !!(
        botData.aiSource?.youtube?.length ||
        botData.aiSource?.confluence?.length ||
        botData.aiSource?.urls?.length ||
        botData.aiSource?.googlepicker?.length ||
        botData.aiSource?.notion?.length ||
        botData.aiSource?.urls?.length ||
        botData.aiSource?.salesforce?.length ||
        botData.aiSource?.documents?.length ||
        !!Object.keys(botData.aiSource?.textArea ?? {})?.length
      );

      botDataClone.aiBotConfig.promptCacheKey = promptCacheKey;

      const data = {
        ...botDataClone,
        startNodeId: 1,
        questions: questionData,
        isTrained,
      };

      const response = await axiosPost("/users/saveBot", data);
      const updatedBotData = response.data.data;

      storeDispatch({
        type: "set-updatedAt",
        updatedAt: updatedBotData.updatedAt,
      });

      if (fromOutgrow) {
        sendEventToOutgrow({ type: "syncUpdatedAt" });
      }

      return updatedBotData;
    },
  });
}
